import {
  Box,
  Container,
  Typography,
  Divider,
  TextField,
  Button,
  Alert,
} from "@mui/material";
import { brands, globalWordings } from "../data";
import { useBrandContext } from "../App";
import { useParams } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { Footer } from "./Footer";

export const AgeDisclaimer = () => {
  const { brand } = useBrandContext();
  const { lang } = useParams();
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [show, setShow] = useState(false);
  const [footerHeight, setFooterHeight] = useState(0);
  const footerRef = useRef(null);

  const validateMinorEighteen = () => {
    const today = new Date();
    const birthDate = new Date(year, month - 1, day);
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();

    return (
      age < 18 ||
      (age === 18 && monthDifference < 0) ||
      (age === 18 &&
        monthDifference === 0 &&
        today.getDate() < birthDate.getDate())
    );
  };

  useEffect(() => {
    const isLocalStorage = localStorage.getItem("ageDisclaimer");
    if (!isLocalStorage) {
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (footerRef.current) {
      const height = footerRef.current.offsetHeight;
      setFooterHeight(height);
    }
  }, [show]);

  const handleContinue = () => {
    localStorage.setItem("ageDisclaimer", "true");
    setShow(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "-" || e.key === "e" || e.key === "E") {
      e.preventDefault();
    }
  };

  const config = {
    year: {
      maxLength: 4,
      minValue: 1900,
      maxValue: new Date().getFullYear(),
    },
    month: {
      maxLength: 2,
      minValue: 1,
      maxValue: 12,
    },
    day: {
      maxLength: 2,
      minValue: 1,
      maxValue: 31,
    },
  };

  const onChangeDateField = (e, field) => {
    let input = e.target.value.replace(/\D/g, "");

    const { maxLength, minValue, maxValue } = config[field];

    if (input.length > maxLength) return;

    if (minValue === 1 && input.startsWith("0")) {
      input = input.slice(1);
    }
    if (input.length === maxLength) {
      const numericInput = parseInt(input, 10);
      input = Math.min(Math.max(numericInput, minValue), maxValue).toString();
    }

    const setState = {
      year: setYear,
      month: setMonth,
      day: setDay,
    };

    setState[field](input);
  };

  if (!show) return null;
  console.log(footerHeight)
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        width: "100vw",
        height: `calc(100vh - ${footerHeight}px)`,
        background: "white",
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "auto",

      }}
      className="age-disclaimer-container"
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          py: 4,
        }}
      >
        <Box
          component="img"
          src={brands[brand].logoColor}
          sx={{
            maxWidth: { xs: 240, md: 300 },
          }}
        />
        <Typography
          variant="bold"
          fontSize={{ xs: 16, md: 20 }}
          textAlign="center"
        >
          {globalWordings[lang]?.ageDisclaimer?.title}
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 6,
            mb: 2,
            gap: { xs: 2, md: 4 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              placeholder="00"
              type="number"
              inputProps={{
                min: 1,
                max: 31,
                style: { textAlign: "center" },
              }}
              sx={{ width: { xs: 100, md: 120 }, textAlign: "center" }}
              value={day}
              pattern="\d*"
              onChange={(e) => onChangeDateField(e, "day")}
              onKeyDown={handleKeyDown}
              max={2}
            />
            <Typography
              variant="bold"
              fontSize={{ xs: 14, md: 16 }}
              mt={{ xs: 1, md: 2 }}
            >
              {globalWordings[lang]?.ageDisclaimer?.day}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              placeholder="00"
              type="number"
              inputProps={{
                min: 1,
                max: 12,
                style: { textAlign: "center" },
              }}
              sx={{ width: { xs: 100, md: 120 }, textAlign: "center" }}
              value={month}
              pattern="\d*"
              onChange={(e) => onChangeDateField(e, "month")}
              onKeyDown={handleKeyDown}
              max={2}
            />
            <Typography
              variant="bold"
              fontSize={{ xs: 14, md: 16 }}
              mt={{ xs: 1, md: 2 }}
            >
              {globalWordings[lang]?.ageDisclaimer?.month}
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <TextField
              variant="outlined"
              placeholder="0000"
              type="number"
              inputProps={{
                min: 1900,
                max: new Date().getFullYear(),
                style: { textAlign: "center" },
              }}
              sx={{ width: { xs: 100, md: 120 }, textAlign: "center" }}
              value={year}
              pattern="\d*"
              onChange={(e) => onChangeDateField(e, "year")}
              onKeyDown={handleKeyDown}
              max={4}
            />
            <Typography
              variant="bold"
              fontSize={{ xs: 14, md: 16 }}
              mt={{ xs: 1, md: 2 }}
            >
              {globalWordings[lang]?.ageDisclaimer?.year}
            </Typography>
          </Box>
        </Box>

        <Divider
          sx={{ width: "100%", my: 3, borderWidth: 1, background: "black" }}
        />

        {validateMinorEighteen() && day && month && year && (
          <Alert severity="error" sx={{ width: "100%", my: 2 }}>
            {globalWordings[lang]?.ageDisclaimer?.error}
          </Alert>
        )}

        <Button
          variant="contained"
          color="primary"
          sx={{ width: "100%", maxWidth: 300, mt: 2 }}
          disabled={validateMinorEighteen() || !day || !month || !year}
          onClick={handleContinue}
        >
          {globalWordings[lang]?.ageDisclaimer?.button}
        </Button>

        <Typography
          fontSize={{ xs: 10, md: 14 }}
          mt={6}
          sx={{
            textTransform: "uppercase",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          {globalWordings[lang]?.ageDisclaimer?.footer}
        </Typography>
      </Container>

      <Box
        ref={footerRef}
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          zIndex: 11,
        }}
      >
        <Footer />
      </Box>
    </Box>
  );
};
